import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Delay showing the banner by 2 seconds
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setAnimateOut(true);
    localStorage.setItem('cookieConsent', 'accepted');
    setTimeout(() => setShowBanner(false), 500); // The timeout should match the CSS animation duration
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className={`cookie-consent ${animateOut ? 'animate-out' : 'animate-in'}`}>
      <div className='cookie-consent__content'>
        <span className="material-symbols-outlined cookie-consent__icon">cookie</span>
        <p className='cookie-consent__text'>
          We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept", you consent to our use of cookies in accordance with our{' '}
          <Link to="/privacy" className="cookie-consent__link">privacy policy</Link>.
        </p>
      </div>
      <button className="cookie-consent__button btn-glass" onClick={handleAccept}>
        <span className="material-symbols-outlined">check</span>
        Accept
      </button>
    </div>
  );
};

export default CookieConsent;
